module.exports = __webpack_public_path__ + "static/img/yy.9b61a08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yy.png
// module id = BCOK
// module chunks = 1